(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2972],{

/***/ 32093:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ calculadora; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toArray.js
var toArray = __webpack_require__(83618);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 1 modules
var emotion_styled_base_browser_esm = __webpack_require__(13179);
// EXTERNAL MODULE: ./shared/components/titles/index.tsx + 1 modules
var titles = __webpack_require__(23814);
// EXTERNAL MODULE: ./node_modules/next-intl/dist/next-intl.cjs.production.min.js
var next_intl_cjs_production_min = __webpack_require__(42746);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
;// CONCATENATED MODULE: ./shared/components-pages/prestamos-calculadora/hero-section/index.tsx



function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }





var logos = [{
  src: "banco_popular_logo.svg",
  alt: "Logo Banco Popular"
}, {
  src: "banco_reservas_logo.svg",
  alt: "Logo Banco Reservas"
}, {
  src: "banco_bhd_logo.svg",
  alt: "Logo Banco BHD"
}, {
  src: "scotiabank_logo.svg",
  alt: "Logo ScotiaBank"
}];

function HeroSection() {
  var translation = (0,next_intl_cjs_production_min.useTranslations)("mortgageCalculator");
  var translationCalculator = (0,next_intl_cjs_production_min.useTranslations)("mortgageCalculator.calculator");
  var title = translation("title") || "";

  var _title$split = title.split(" "),
      _title$split2 = (0,toArray/* default */.Z)(_title$split),
      first = _title$split2[0],
      rest = _title$split2.slice(1);

  return (0,emotion_react_browser_esm/* jsx */.tZ)(Wrapper, null, (0,emotion_react_browser_esm/* jsx */.tZ)(ImageWrapper, null), (0,emotion_react_browser_esm/* jsx */.tZ)(Content, null, (0,emotion_react_browser_esm/* jsx */.tZ)(ContentLogos, null, logos.map(function (item) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)(BankLogos, {
      src: "/icons/".concat(item.src),
      alt: item.alt,
      key: item.src
    });
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(ContentDetails, null, (0,emotion_react_browser_esm/* jsx */.tZ)(titles/* TitleThickThin */.U, {
    component: "h1",
    thickTitle: first,
    thinTitle: rest.join(" "),
    color: "--color-brand-bg-secondary",
    align: "left",
    mb: "30px"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("p", null, translationCalculator("instruction")), (0,emotion_react_browser_esm/* jsx */.tZ)("p", null, translationCalculator("description")))));
}

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "ebu2ifx5"
} : 0)( true ? {
  name: "1op05ko",
  styles: "width:100%;height:976px;position:relative;margin-bottom:-200px;@media screen and (max-width: 991px){height:auto;}@media screen and (max-width: 570px){margin-bottom:0;}"
} : 0);

var ImageWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ebu2ifx4"
} : 0)( true ? {
  name: "aaoym7",
  styles: "background-position:top center;background-size:cover;background-repeat:no-repeat;width:100%;height:100%;background-image:url(\"/images/image-optimize/calculadora_de_prestamos_background.webp\");@media screen and (max-width: 991px){height:60vw;background-position:top center;}"
} : 0);

var Content = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ebu2ifx3"
} : 0)( true ? {
  name: "4wxm36",
  styles: "position:absolute;left:105px;bottom:0;width:501px;@media screen and (max-width: 991px){position:static;width:100%;}"
} : 0);

var ContentLogos = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ebu2ifx2"
} : 0)( true ? {
  name: "1jgoiit",
  styles: "background-color:var(--color-brand-bg-secondary);border-radius:100px;width:100%;height:86px;max-width:448px;margin:0 auto 100px;padding:0 50px;display:flex;justify-content:space-around;align-items:center;@media screen and (max-width: 991px){max-width:none;border-radius:0;margin-bottom:0;justify-content:center;}"
} : 0);

var ContentDetails = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ebu2ifx1"
} : 0)( true ? {
  name: "3dowza",
  styles: "background-color:var(--color-brand-blue-main);height:580px;padding:70px 39px 39px;&>p{color:var(--color-brand-bg-secondary);font-size:0.938rem;font-weight:400;margin-bottom:20px;line-height:18px;}@media screen and (max-width: 570px){height:auto;}@media screen and (max-width: 991px){&>*{max-width:720px;margin-left:auto;margin-right:auto;}}@media screen and (max-width: 767px){&>*{max-width:540px;}}"
} : 0);

var BankLogos = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("img",  true ? {
  target: "ebu2ifx0"
} : 0)( true ? {
  name: "18624vu",
  styles: "@media screen and (max-width: 991px){margin:0 12px;}"
} : 0);

/* harmony default export */ var hero_section = (HeroSection);
// EXTERNAL MODULE: ./shared/components/loan-calculator/index.tsx + 1 modules
var loan_calculator = __webpack_require__(15702);
;// CONCATENATED MODULE: ./shared/components-pages/prestamos-calculadora/loan-calculator-section/index.tsx


function loan_calculator_section_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }





function LoanCalculatorSection(props) {
  return (0,emotion_react_browser_esm/* jsx */.tZ)(loan_calculator_section_Wrapper, null, (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "container"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(loan_calculator/* default */.Z, {
    disableLoanAmount: false
  })));
}

var loan_calculator_section_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "e1qq4h6g0"
} : 0)( true ? {
  name: "1ulcxie",
  styles: "border-radius:200px 0px 0px 0px;position:relative;background-color:#f3f3f5;padding:100px 0 130px;@media screen and (max-width: 991px){border-radius:150px 0px 0px 0px;}@media screen and (max-width: 570px){border-radius:0;}"
} : 0);

/* harmony default export */ var loan_calculator_section = (LoanCalculatorSection);
// EXTERNAL MODULE: ./shared/components/head-meta/index.tsx
var head_meta = __webpack_require__(23385);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./pages/prestamos/calculadora/index.tsx







var CalculadoraPrestamos = function CalculadoraPrestamos() {
  var router = (0,next_router.useRouter)();
  var metaData = {
    title: "loansCalculator",
    description: "LoanCalculator",
    url: router.asPath,
    og_type: "page-frequentQuestions"
  };
  return (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, (0,emotion_react_browser_esm/* jsx */.tZ)(head_meta/* default */.Z, metaData), (0,emotion_react_browser_esm/* jsx */.tZ)(hero_section, null), (0,emotion_react_browser_esm/* jsx */.tZ)(loan_calculator_section, null));
};

var __N_SSG = true;
/* harmony default export */ var calculadora = (CalculadoraPrestamos);

/***/ }),

/***/ 23385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_dist_shared_lib_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72717);
/* harmony import */ var next_dist_shared_lib_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_dist_shared_lib_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42746);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_intl__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _helpers_removeparams__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57626);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70917);






function HeadMeta(props) {
  var title = props.title,
      description = props.description,
      url = props.url,
      og_type = props.og_type,
      picture = props.picture,
      canonical = props.canonical,
      keyWords = props.keyWords;
  var titleT = (0,next_intl__WEBPACK_IMPORTED_MODULE_2__.useTranslations)("title-pages");
  var MetaDescriptionT = (0,next_intl__WEBPACK_IMPORTED_MODULE_2__.useTranslations)("metaDescriptions");
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)((next_dist_shared_lib_head__WEBPACK_IMPORTED_MODULE_0___default()), null, title && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("title", null, titleT(title)), description && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    name: "description",
    content: description
  }), keyWords && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    name: "keywords",
    content: keyWords
  }), url && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    property: "og:url",
    content: "".concat("https://unete.remaxrd.com").concat(url)
  }), og_type && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    property: "og:type",
    content: og_type
  }), title && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    property: "og:title",
    content: title
  }), description && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    property: "og:description",
    content: MetaDescriptionT(description)
  }), picture && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    property: "og:image",
    content: "https://unete.remaxrd.com" + picture
  }), (url || canonical) && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("link", {
    rel: "canonical",
    href: (0,_helpers_removeparams__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("".concat("https://unete.remaxrd.com").concat(canonical !== null && canonical !== void 0 ? canonical : url)),
    key: "canonical"
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (HeadMeta);

/***/ }),

/***/ 78836:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70917);
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }





var LabelField = function LabelField(props) {
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("span", {
    css: styles.label,
    className: "label-customs ".concat(props.positionLabel)
  }, props.label);
};

/* harmony default export */ __webpack_exports__["Z"] = (LabelField);
var styles = {
  label:  true ? {
    name: "8knltz",
    styles: "width:100%;display:block;padding-left:10px;font-size:0.9375rem;font-weight:600;line-height:21px;color:var(--color-brand-blue-main);vertical-align:bottom !important;margin-bottom:10px;&.center{text-align:center;}&.left:{text-align:left;}&.right:{text-align:right;}"
  } : 0
};

/***/ }),

/***/ 95114:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H3": function() { return /* binding */ PercentInput; },
/* harmony export */   "Lj": function() { return /* binding */ CedulaMask; },
/* harmony export */   "MX": function() { return /* binding */ TextMaskInput; },
/* harmony export */   "PK": function() { return /* binding */ MoneyInput; },
/* harmony export */   "Qv": function() { return /* binding */ PhoneMask; },
/* harmony export */   "Y2": function() { return /* binding */ NumberInput; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36864);
/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_number_format__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57333);
/* harmony import */ var react_text_mask__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91749);
/* harmony import */ var react_text_mask__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_text_mask__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70917);


var _excluded = ["onChange"],
    _excluded2 = ["onChange"],
    _excluded3 = ["value"],
    _excluded4 = ["onChange", "inputProps"],
    _excluded5 = ["onChange"];




var NumberInput = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function NumberInput(props, ref) {
  var _props$onChange = props.onChange,
      onChange = _props$onChange === void 0 ? function () {} : _props$onChange,
      other = (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props, _excluded);

  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(react_number_format__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, other, {
    onValueChange: function onValueChange(values) {
      onChange(values.value);
    },
    getInputRef: ref
  }));
});
var PercentInput = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function NumberInput(props, ref) {
  var _props$onChange2 = props.onChange,
      onChange = _props$onChange2 === void 0 ? function () {} : _props$onChange2,
      other = (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props, _excluded2);

  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(react_number_format__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, other, {
    suffix: "%",
    onValueChange: function onValueChange(values) {
      onChange(values.value);
    },
    getInputRef: ref
  }));
});
var MoneyInput = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function MoneyInput(props, ref) {
  var value = props.value,
      rest = (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props, _excluded3);

  var normalizedValue = value === null || value === undefined ? "" : typeof value === "number" ? String(value) : value;
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(NumberInput, (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
    prefix: "$",
    thousandSeparator: true,
    allowNegative: false,
    ref: ref,
    value: normalizedValue
  }, rest));
});
var PhoneMask = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function PhoneMask(props, ref) {
  var _ref2, _props$format;

  var _ref = props,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
      _ref$inputProps = _ref.inputProps,
      inputProps = _ref$inputProps === void 0 ? {} : _ref$inputProps,
      rest = (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded4); // Permitir definir formato ya sea como prop directo o dentro de inputProps (MUI InputBase)


  var format = (_ref2 = (_props$format = props.format) !== null && _props$format !== void 0 ? _props$format : inputProps.format) !== null && _ref2 !== void 0 ? _ref2 : "(###) ###-####";
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(react_number_format__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
    format: format,
    mask: "_",
    allowNegative: false,
    isNumericString: true,
    onValueChange: function onValueChange(values) {
      onChange(values.value);
    },
    getInputRef: ref
  }, rest));
});
var CedulaMask = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function CedulaMask(props, ref) {
  var _props$onChange3 = props.onChange,
      onChange = _props$onChange3 === void 0 ? function () {} : _props$onChange3,
      rest = (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props, _excluded5);

  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(react_number_format__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
    format: "###-#######-#",
    mask: "_",
    allowNegative: false,
    getInputRef: ref,
    onValueChange: function onValueChange(values) {
      onChange(values.value);
    }
  }, rest));
});
var TextMaskInput = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function TextMaskInput(props, ref) {
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)((react_text_mask__WEBPACK_IMPORTED_MODULE_2___default()), (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
    mask: function mask(s) {
      return Array.from(s).map(function () {
        return /[a-z\s]/i;
      });
    },
    guide: false,
    getInputRef: ref
  }, props));
});

/***/ }),

/***/ 22900:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "k": function() { return /* reexport */ default_text_field; },
  "Z": function() { return /* reexport */ formik_text_field; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(17674);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82580);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(36864);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 1 modules
var emotion_styled_base_browser_esm = __webpack_require__(13179);
// EXTERNAL MODULE: ./node_modules/@mui/material/Input/Input.js
var Input = __webpack_require__(79332);
// EXTERNAL MODULE: ./shared/components/label-field/index.tsx
var label_field = __webpack_require__(78836);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
;// CONCATENATED MODULE: ./shared/components/text-field/default-text-field.tsx




var _excluded = ["label", "value", "errorsComponents"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







function DefaultTextField(props) {
  var label = props.label,
      value = props.value,
      errorsComponents = props.errorsComponents,
      res = (0,objectWithoutProperties/* default */.Z)(props, _excluded);

  var onChange = function onChange(e) {
    if (props !== null && props !== void 0 && props.onChange) {
      props.onChange(e);
    }
  };

  var config = _objectSpread(_objectSpread(_objectSpread({}, res), {
    id: props.name
  }), {}, {
    onChange: onChange
  });

  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    css: styles.contentInput,
    className: "content-input-field"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(label_field/* default */.Z, {
    label: label,
    positionLabel: props.positionLabel
  }), (0,emotion_react_browser_esm/* jsx */.tZ)(Input/* default */.Z, (0,esm_extends/* default */.Z)({
    label: undefined,
    css: styles.inputField,
    disableUnderline: true
  }, config, {
    value: value
  })), errorsComponents && /*#__PURE__*/react.cloneElement(errorsComponents));
}

/* harmony default export */ var default_text_field = (DefaultTextField);
var styles = {
  inputField:  true ? {
    name: "n2fz1z",
    styles: "width:100%;outline:none;border:1px solid var(--color-brand-border);border-radius:50px;padding:8px 23px;background:none;color:var(--color-brand-blue-main);font-family:var(--font-family);font-style:normal;font-weight:700;font-size:var( --fs-body-small);line-height:21px;& input::placeholder{color:var(--color-brand-blue-main);opacity:1;}&:hover{border:1px solid var(--color-brand-blue-collection-main);}"
  } : 0,
  contentInput:  true ? {
    name: "1d3w5wq",
    styles: "width:100%"
  } : 0,
  inputErrors:  true ? {
    name: "1sc7l0d",
    styles: "width:100%;color:var(--color-brand-red-secondary);font-weight:500;padding-left:10px;font-size:0.8125rem;display:flex;align-items:center;& .iconError{font-size:0.8125rem;margin-right:3px;}"
  } : 0
};

var Errors = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled("span",  true ? {
  target: "eq6sl9n0"
} : 0)( true ? "" : 0)));
;// CONCATENATED MODULE: ./shared/components/text-field/formik-text-field.tsx



var formik_text_field_excluded = ["name", "onChange"];

function formik_text_field_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function formik_text_field_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? formik_text_field_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : formik_text_field_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function formik_text_field_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







function FormikTextField(props) {
  var _useField = (0,formik_esm/* useField */.U$)(props),
      _useField2 = (0,slicedToArray/* default */.Z)(_useField, 3),
      field = _useField2[0],
      meta = _useField2[1],
      helpers = _useField2[2];

  var name = props.name,
      onChange = props.onChange,
      res = (0,objectWithoutProperties/* default */.Z)(props, formik_text_field_excluded);

  var handleChange = function handleChange(value) {
    if (value.target) {
      field.onChange(value);
    } else {
      helpers.setValue(value);
    }
  };

  var config = formik_text_field_objectSpread(formik_text_field_objectSpread(formik_text_field_objectSpread(formik_text_field_objectSpread({}, field), res), {
    id: name
  }), {}, {
    onChange: props.onChange || handleChange,
    errorsComponents: ErrorsComponents({
      meta: meta
    })
  });

  return (0,emotion_react_browser_esm/* jsx */.tZ)(default_text_field, config);
}

/* harmony default export */ var formik_text_field = (FormikTextField);

var ErrorsComponents = function ErrorsComponents(_ref) {
  var meta = _ref.meta;
  return (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, meta.error && meta.touched && (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    css: formik_text_field_styles.inputErrors
  }, meta.error));
};

var formik_text_field_styles = {
  inputField:  true ? {
    name: "n2fz1z",
    styles: "width:100%;outline:none;border:1px solid var(--color-brand-border);border-radius:50px;padding:8px 23px;background:none;color:var(--color-brand-blue-main);font-family:var(--font-family);font-style:normal;font-weight:700;font-size:var( --fs-body-small);line-height:21px;& input::placeholder{color:var(--color-brand-blue-main);opacity:1;}&:hover{border:1px solid var(--color-brand-blue-collection-main);}"
  } : 0,
  contentInput:  true ? {
    name: "1d3w5wq",
    styles: "width:100%"
  } : 0,
  inputErrors:  true ? {
    name: "1sc7l0d",
    styles: "width:100%;color:var(--color-brand-red-secondary);font-weight:500;padding-left:10px;font-size:0.8125rem;display:flex;align-items:center;& .iconError{font-size:0.8125rem;margin-right:3px;}"
  } : 0
};
;// CONCATENATED MODULE: ./shared/components/text-field/index.tsx




/***/ }),

/***/ 23814:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* reexport */ titles_TitleThickThin; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71383);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js
var emotion_styled_browser_esm = __webpack_require__(37337);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
;// CONCATENATED MODULE: ./shared/components/titles/TitleThickThin.tsx



var _templateObject;

var _excluded = ["component", "align", "fw", "color", "fs", "mb"];




var TitleThickThin = function TitleThickThin(props) {
  var _props$component = props.component,
      component = _props$component === void 0 ? "h2" : _props$component,
      _props$align = props.align,
      align = _props$align === void 0 ? "center" : _props$align,
      _props$fw = props.fw,
      fw = _props$fw === void 0 ? 600 : _props$fw,
      _props$color = props.color,
      color = _props$color === void 0 ? "--color-text-black" : _props$color,
      _props$fs = props.fs,
      fs = _props$fs === void 0 ? "--fs-sub-title-large" : _props$fs,
      _props$mb = props.mb,
      mb = _props$mb === void 0 ? "60px" : _props$mb,
      rest = (0,objectWithoutProperties/* default */.Z)(props, _excluded);

  var Title = emotion_styled_browser_esm/* default */.Z[component](_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin: auto;\n    font-family: var(--font-family);\n    font-size: 27.2px;\n    font-weight: ", ";\n    line-height: 21px;\n    letter-spacing: 0px;\n    color: var(", ");\n    text-align: ", ";\n    margin-bottom:", " !important;\n    & span{\n      font-weight: 400;\n      font-family: var(--font-family);\n    }\n  "])), fw, color, align, mb);
  return (0,emotion_react_browser_esm/* jsx */.tZ)(Title, {
    className: props.titleClass
  }, props.thickTitle, " ", (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: props.thickTitle
  }, props.thinTitle));
};

/* harmony default export */ var titles_TitleThickThin = (TitleThickThin);
;// CONCATENATED MODULE: ./shared/components/titles/index.tsx



/***/ }),

/***/ 55654:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/prestamos/calculadora",
      function () {
        return __webpack_require__(32093);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,3662,2708,1629,8407,70,7918,9043,8543,2960,311,4816,8360,8638,2753,1915,2888,179], function() { return __webpack_exec__(55654); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);